import { render, staticRenderFns } from "./DialogCreateTeam.vue?vue&type=template&id=dca8c35e&scoped=true"
import script from "./DialogCreateTeam.vue?vue&type=script&lang=js"
export * from "./DialogCreateTeam.vue?vue&type=script&lang=js"
import style0 from "./DialogCreateTeam.vue?vue&type=style&index=0&id=dca8c35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca8c35e",
  null
  
)

export default component.exports